import icon from "assets/icons/barbershop.png";

export default function ShopIcon({ size = 24 }) {
  return <img src={icon} alt="Shop" width={size} height={size} />;
}
